import { message } from 'antd';
import { FC, ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutSite } from '../components/layout';
import { getlast } from '../services/api.service';
import './datas.scss';
import { Header } from '../components/header';

/* -------------------------------------------------------------------------------- *\
|                               DatasPage
\* -------------------------------------------------------------------------------- */
export const DatasPage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [datas, setDatas] = useState<string[]>([]);
    const navigate = useNavigate();

    /* -------------------------------------------------------------------------------- *\
    |                               getDatas
    \* -------------------------------------------------------------------------------- */
    const getDatas = async () =>
    {
        getlast()
            .then((datas: any) =>
            {
                setDatas(["get \n\n" + JSON.stringify(datas.getresults, null, 2), "post \n\n" + JSON.stringify(datas.postresults, null, 2)]);
            })
            .catch(error =>
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            });
    }
    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() =>
    {
        const interval = setInterval(() =>
        {
            getDatas();
        }, 1000);
        return () => clearInterval(interval);
        // eslint-disable-next-line
    }, []);
    
    return (
        <LayoutSite>
            <Header title="Technical live datas"></Header>
            <div className="datas">
                <div className="datas__body">
                    <div className='datas__body__datas'>
                        {
                            datas.map((d, i) =>
                            {
                                return (<div key={i}  className='datas__body__preview'>{d}</div>);
                            })
                        }
                    </div>
                    {
                        datas.length === 0 &&
                        <div className='datas__body__norace'>There is no live data currently</div>
                    }
                </div>
            </div>
        </LayoutSite>
    );
}
